import styles from '../../../pages/FormPage.module.scss';
import UnionRoleSelect from './UnionRole';
import UnionContact from './UnionContact';
import { UnionSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';

type Props = {
  texts?: UnionSectionTexts;
};

const infoText = `
<div>
<strong>Kontaktuppgifter</strong> <br />
Vänligen fyll i fackförbundets kontaktperson, det vill säga den person från fackförbundet som förhandlat om uppsägningen. <br />
Vill du ange fler kontaktpersoner fyller du i det  i fältet  "Övrigt" i nästa steg.</div>
`;

const UnionContactDetails = ({ texts }: Props) => {
  return (
    <>
      <div
        className={styles.preamble}
        dangerouslySetInnerHTML={{
          __html: texts?.unionOrganizationInfo ?? infoText,
        }}
      />
      <UnionRoleSelect texts={texts} />
      <UnionContact texts={texts} />
    </>
  );
};

export default UnionContactDetails;
